import { createAction, props } from '@ngrx/store';

export const getBookingConfigs = createAction('[Booking] Get Booking Configs');
export const getBookingConfigsSuccess = createAction('[Booking] Get Booking Configs Success.', props<{ data: any }>());
export const getBookingConfigsFailure = createAction('[Booking] Get Booking Configs Failure', props<{ error: any }>());
